import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchChangeHistory} from "../../../../../redux/actions/autoLombardActions";
import moment from "moment";
import {useParams} from "react-router-dom";
import ReactModal from "react-modal";

const ChangeHistory = () => {
    const dispatch = useDispatch();
    const [selectedImage, setSelectedImage] = useState(null);
    const { changeHistory } = useSelector(({ autolombard }) => autolombard.currentRequest);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {id} = useParams();

    useEffect(() => {
        dispatch(fetchChangeHistory({id: id}));
    }, []);

    const getFieldLabel = (fieldName) => {
        const fieldLabels = {
            brand: "Марка автомобиля",
            model: "Модель автомобиля",
            yearOfManufacture: "Год выпуска",
            odometer: "Пробег",
            vin: "Vin-номер",
            photo: "Фото",
            stateNumber: "Гос номер",
            file: "Документы",
            vehiclePhotos: "Фото ТС",
            registrationDocumentPhotos: "Фото ПТС",
            desiredAmount: 'Желаемая сумма займа',
            desiredTerm: 'Желательный срок займа',
        };
        return fieldLabels[fieldName] || fieldName;
    };

    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setIsModalOpen(true);
    };

    const renderValue = (fieldName, value) => {
        if (!value) return '—';
        if (fieldName === 'vehiclePhotos' || fieldName === 'registrationDocumentPhotos') {
            return (
                <img
                    className='changeHistory-image'
                    src={value}
                    alt="Изображение"
                    onClick={() => handleImageClick(value)}
                    style={{cursor: 'pointer'}}
                />
            );
        }

        return value;
    };

    return (
        <div>
            <table>
                <thead>
                <tr className="table-header">
                    <th className="table-header-cell changeHistory-tableHeader">Дата изменения</th>
                    <th className="table-header-cell changeHistory-tableHeader">Изменил</th>
                    <th className="table-header-cell changeHistory-tableHeader">Поле</th>
                    <th className="table-header-cell changeHistory-tableHeader">Старое значение</th>
                    <th className="table-header-cell changeHistory-tableHeader">Новое значение</th>
                    <th className="table-header-cell changeHistory-tableHeader">Комментарий</th>
                </tr>
                </thead>
                <tbody>
                {changeHistory?.map((change, index) => (
                    <tr key={index} className={change.changedByClient ? 'changeHistory-isClientEditeble' : ''}>
                        <td className="table-cell">
                            {moment(change.date).format('DD.MM.YYYY')}
                        </td>
                        <td className="table-cell">
                            {getFieldLabel(change.changedBy)}
                        </td>
                        <td className="table-cell">
                            {getFieldLabel(change.fieldName)}
                        </td>
                        <td className="table-cell">
                            {renderValue(change.fieldName, change.previousValue)}
                        </td>
                        <td className="table-cell">
                            {renderValue(change.fieldName, change.nextValue)}
                        </td>
                        <td className="table-cell changeHistory-comment">
                            {change.comment}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            <ReactModal
                isOpen={isModalOpen}
                contentLabel="Image Preview"
                className="image-modal"
                overlayClassName="image-modal-overlay"
                onRequestClose={() => setIsModalOpen(false)}
                closeTimeoutMS={200}
            >
                {selectedImage && (
                    <div className="image-modal-content">
                        <button
                            className="image-modal-close"
                            onClick={() => setIsModalOpen(false)}
                        >
                            &times;
                        </button>
                        <img
                            src={selectedImage}
                            alt="Увеличенное изображение"
                            className="image-modal-img"
                        />
                    </div>
                )}
            </ReactModal>
        </div>
    );
};

export default ChangeHistory;